/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MezziResponseDTO,
} from '../models/index';
import {
    MezziResponseDTOFromJSON,
    MezziResponseDTOToJSON,
} from '../models/index';

export interface GetMezziRequest {
    idPersonale?: number;
}

/**
 * 
 */
export class MezziApi extends runtime.BaseAPI {

    /**
     */
    async getMezziRaw(requestParameters: GetMezziRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MezziResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Mezzi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MezziResponseDTOFromJSON));
    }

    /**
     */
    async getMezzi(requestParameters: GetMezziRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MezziResponseDTO>> {
        const response = await this.getMezziRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
